import {
  SandpackFiles,
  SandpackProviderProps,
} from "@codesandbox/sandpack-react";
import { amethyst } from "@codesandbox/sandpack-themes";

export type TProjectEnvs = "SANDPACK" | "GITHUB";

export const spOptions: SandpackProviderProps = {
  template: "vanilla",
  theme: {
    ...amethyst,
    font: {
      size: "14px",
      lineHeight: "21px",
    },
  },
  options: {
    autoReload: false,
  },
};

export interface ITestResult {
  name: string;
  status: "fail" | "pass";
}

export interface ITestStatus {
  status: "RUNNING" | "IDLE";
  results: null | ITestResult[];
}

export const initialReactFiles: SandpackFiles = {
  "App.js": `export default function App() {
  return "Hello World";
}

export function add(num1, num2) {
  return num1 + num2;
}
`,
  "App.test.js": `import { add } from './App.js';

describe('add', () => {
  test('Commutative Law of Addition', () => {
    expect(add(3, 2)).toBe(add(2, 3));
  });
});`,
};

export interface IProjectUserData {
  project: {
    id: number;
    infos: {
      title: string;
      description: string;
    };
    files: JSON;
    project_url: string;
    environment: TProjectEnvs;
    env_configs: {
      filesToSave: string[];
      spOptions?: SandpackProviderProps;
    };
    java_config: string;
    project_solution_id: string;
  };
  user_files: JSON | null;
}

export interface ISandpackProjectLog {
  user_id: number;
  project_id: number;
  user_score: number;
  is_auto: boolean;
  user_files: SandpackFiles;
}

export const calculateRate = (data: null | ITestResult[]) => {
  const passed = data?.filter((f) => f.status === "pass");
  const failed = data?.filter((f) => f.status === "fail");
  const rate =
    data &&
    data?.length > 0 &&
    passed?.length !== undefined &&
    failed?.length !== undefined
      ? (passed?.length * 100) / (passed.length + failed?.length)
      : null;

  return rate;
};
